import styled from 'styled-components';


export const Menu = styled.nav`

/*  Menu lateral   */
.tm-sidebar-left {
    position: fixed;
    z-index: 100;
    top:60px;
    bottom: 0;
    box-sizing: border-box;
    width: 240px;
    border-right: 1px #e5e5e5 solid;
    overflow-y: auto;
    overflow-x: hidden;
    transition: 0.5s;
    background: #fff;
}

.uk-nav-divider {
    margin: 2px 0;
}

.uk-nav-default>li>a:hover {
    color: #EB4626;
    background-color: rgba(63, 69, 81, 0.10);
}


.uk-left-menu-active{
    left: -260px!important;
    transition: 0.5s;
}

.uk-left-menu-inative{
    left: 0;
    transition: 0.5s;
}

.uk-nav>li>a {
    padding: 8px;
}


@media only screen and (max-width: 800px) {

    .uk-left-menu-active{
        left: 0px!important;
    }

    .uk-left-menu-inative{
        left: -240px;
        transition: 0.5s;
    }

    .content-padder-active{
        margin-left: 0px;
        transition: 0.5s;
    }

    .content-padder-inative{
        margin-left: 0px;
        transition: 0.5s;
    }

}

   
`